/* eslint-disable  react/jsx-boolean-value, no-unused-vars */

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import styled from 'styled-components'

import theme from '../../utils/theme'
import DeviceWrap from '../RegoFormPreview/components/DeviceWrap'

const styles = theme => ({
  innerWrapper: {
    width: '100%',
    transitionProperty: 'width',
    transitionDuration: '500ms',
    '&.viewMobile': {
      width: '310px',
    },
  },
  nav: {
    height: '50px',
    padding: '0 8px',
    backgroundColor: theme.colors.white,
  },
  topAndBottomBorder: {
    borderTop: `1px solid ${theme.colors.midGrey}`,
    borderBottom: `1px solid ${theme.colors.midGrey}`,
  },
  dateAndRegister: props => ({
    position: 'relative',
    display: 'flex',
    maxWidth: '100%',
    alignItems: 'center',
    top: props.viewMobile ? '-50px' : '-35px',
    marginBottom: props.viewMobile ? '-50px' : '-35px',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: props.viewMobile ? '95%' : '540px',
    height: props.viewMobile ? '100px' : '70px',
    borderRadius: '15px',
    backgroundColor: props.buttonColor || theme.colors.midGrey,
  }),
  hero: props => ({
    background: `linear-gradient(30deg,${props.gradientOne}44 5%, ${props.gradientTwo} 95%), ${props.gradientOne}`,
    height: '271px',
  }),
})

const StyledLandingPagePreview = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
  background: ${theme.colors.offWhite};
  align-items: center;
  * {
    transition: ${theme.transitions.smooth};
  }
`

const Block = styled.div`
  display: flex;
  width: ${props => props.width || '100%'};
  height: ${props => props.height || 'auto'};
  padding: ${props => props.padding};
  margin: ${props => props.margin};
  flex-direction: ${props => (props.column ? 'column' : 'row')};
  align-items: ${props => props.align || 'flex-start'};
  justify-content: ${props => props.justify || 'flex-start'};
  background-color: ${props => props.bg};
  flex-wrap: ${props => props.wrap};
  border-radius: ${props => props.radius};
  gap: ${props => props.gap};
  border: ${props => props.border};
  flex-shrink: ${props => (props.disableShrink ? 0 : 1)};
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
`

const Circle = styled.div`
  width: ${props => props.width || '8px'};
  height: ${props => props.height || '8px'};
  margin: ${props => props.margin || '0 2px'};
  background-color: ${props => props.bg};
  border-radius: 100%;
  flex-shrink: 0;
`

const LandingPagePreview = ({
  classes,
  buttonColor,
  buttonTextColor,
  textLinkColour,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  gradientOne,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  gradientTwo,
  viewMobile,
}) => {
  return (
    <StyledLandingPagePreview className={cn(viewMobile && 'view-mobile')}>
      <DeviceWrap>
        <div className={cn(classes.innerWrapper)}>
          <Block className={classes.nav} align="center" justify="space-between">
            <Block align="center">
              <Block width="60px" height="30px" radius="5px" margin="0 7px 0 0" bg={theme.colors.midGrey} />
              {!viewMobile && (
                <Block gap="0 7px">
                  <Block width="40px" height="13px" radius="5px" bg={theme.colors.midGrey} />
                  <Block width="40px" height="13px" radius="5px" bg={theme.colors.midGrey} />
                  <Block width="40px" height="13px" radius="5px" bg={theme.colors.midGrey} />
                  <Block width="40px" height="13px" radius="5px" bg={theme.colors.midGrey} />
                </Block>
              )}
            </Block>
            <Block align="center" justify="flex-end">
              {!viewMobile && (
                <>
                  <Block gap="0 7px" justify="flex-end">
                    <Block width="15px" height="15px" radius="5px" bg={theme.colors.midGrey} />
                    <Block width="15px" height="15px" radius="5px" bg={theme.colors.midGrey} />
                    <Block width="15px" height="15px" radius="5px" bg={theme.colors.midGrey} />
                  </Block>
                  <Block
                    width="40px"
                    height="13px"
                    radius="5px"
                    margin="0 5px 0 30px"
                    bg={theme.colors.midGrey}
                    disableShrink={true}
                  />
                </>
              )}
              <Circle width="30px" height="30px" bg={theme.colors.midGrey} />
            </Block>
          </Block>
          <Block className={classes.hero} align="center" justify="center">
            <Block justify="center" align="center" width={!viewMobile ? '431px' : '230px'} column={true} gap="13px">
              <Block width="80%" height="26px" radius="5px" bg={theme.colors.white} />
              <Block width="100%" height="26px" radius="5px" bg={theme.colors.white} />
            </Block>
          </Block>
          <div className={classes.dateAndRegister}>
            <Block
              justify={!viewMobile ? 'space-between' : 'center'}
              gap={viewMobile && '20px 0'}
              align="center"
              padding="0 25px"
              wrap="wrap"
            >
              <Block
                width={!viewMobile ? '40%' : '80%'}
                height="16px"
                align="center"
                radius="4px"
                bg={buttonTextColor}
              />
              <Block width={!viewMobile ? '40%' : '100%'} height="27px" justify="flex-end" gap="10px" align="center">
                <Block width={!viewMobile ? '45%' : '50%'} height="100%" radius="4px" bg={buttonTextColor} />
                <Block
                  width={!viewMobile ? '45%' : '50%'}
                  height="100%"
                  radius="4px"
                  border={`1px solid ${buttonTextColor}`}
                  align="center"
                  justify="center"
                >
                  <Block bg={buttonTextColor} width="60%" height="35%" radius="3px" />
                </Block>
              </Block>
            </Block>
          </div>
          <Block
            bg={theme.colors.white}
            justify="center"
            align={!viewMobile ? 'center' : 'flex-end'}
            height="400px"
            margin={!viewMobile ? '-70px 0 0 0' : '-100px 0 0 0'}
          >
            <Block
              height={!viewMobile ? '278px' : '85%'}
              width="540px"
              align="center"
              column={viewMobile}
              justify={!viewMobile ? 'space-between' : 'space-around'}
              gap={!viewMobile && '25px'}
            >
              {viewMobile && <Block width="95%" height="50px" radius="5px" bg={theme.colors.lightGrey} />}
              {!viewMobile && (
                <Block
                  width="38%"
                  height="100%"
                  padding="25px 20px 20px"
                  column={true}
                  justify="space-between"
                  align="flex-end"
                  bg={theme.colors.lightGrey}
                  radius="5px"
                >
                  <Block width="80%" height="9px" radius="4px" bg={textLinkColour} />
                  <Block width="80%" height="9px" radius="4px" bg={textLinkColour} />
                  <Block width="80%" height="9px" radius="4px" bg={textLinkColour} />
                  <Block width="80%" height="9px" radius="4px" bg={textLinkColour} />
                  <Block width="80%" height="9px" radius="4px" bg={textLinkColour} />
                  <Block width="80%" height="9px" radius="4px" bg={textLinkColour} />
                  <Block width="80%" height="9px" radius="4px" bg={textLinkColour} />
                  <Block width="100%" height="25px" radius="5px" margin="10px 0 0 0" bg={buttonColor} />
                </Block>
              )}
              <Block
                height="95%"
                width={viewMobile && '95%'}
                padding="10px 0 20px"
                margin={viewMobile && '0 0 15px 0'}
                column={true}
                justify="space-between"
              >
                <Block width="45%" height="25px" radius="5px" margin="15px 0" bg={theme.colors.midGrey} />
                <Block width="100%" height="3px" radius="2px" bg={theme.colors.midGrey} />
                <Block width="100%" height="3px" radius="2px" bg={theme.colors.midGrey} />
                <Block width="100%" height="3px" radius="2px" bg={theme.colors.midGrey} />
                <Block width="100%" height="3px" radius="2px" bg={theme.colors.midGrey} />
                <Block width="100%" height="3px" radius="2px" bg={theme.colors.midGrey} />
                <Block width="100%" height="3px" radius="2px" bg={theme.colors.midGrey} />
                <Block width="100%" height="3px" radius="2px" bg={theme.colors.midGrey} />
                <Block width="100%" height="3px" radius="2px" bg={theme.colors.midGrey} />
                <Block width="100%" height="3px" radius="2px" bg={theme.colors.midGrey} />
                <Block width="100%" height="3px" radius="2px" bg={theme.colors.midGrey} />
                <Block width="80%" height="3px" radius="2px" bg={theme.colors.midGrey} />
              </Block>
            </Block>
          </Block>
          <Block bg={theme.colors.lightGrey} justify="space-around" align="center" column={true} padding="50px 0 35px">
            <Block width="520px" gap="20px" justify="center" align="center">
              <Block
                height="220px"
                width={!viewMobile ? '30%' : '208px'}
                radius="4px"
                bg={theme.colors.white}
                justify="center"
              />
              {!viewMobile && (
                <>
                  <Block height="220px" width="30%" radius="4px" bg={theme.colors.white} />
                  <Block height="220px" width="30%" radius="4px" bg={theme.colors.white} />
                </>
              )}
            </Block>
            <Block
              width={!viewMobile ? '17%' : '123px'}
              height="20px"
              radius="5px"
              margin="35px 0 0 0"
              bg={buttonColor}
            />
          </Block>
          <Block bg={theme.colors.white} align="center" justify="center" padding={!viewMobile ? '50px 0' : '35px 0'}>
            <Block width="540px" column={true} align="center" justify="center" gap="30px">
              <Block
                height="56px"
                gap="10px"
                justify="space-between"
                align="center"
                margin={viewMobile && '0 0 0 50px'}
              >
                <Block width="99px" height="100%" radius="4px" bg={theme.colors.lightGrey} disableShrink={viewMobile} />
                <Block width="99px" height="100%" radius="4px" bg={theme.colors.lightGrey} disableShrink={viewMobile} />
                <Block width="99px" height="100%" radius="4px" bg={theme.colors.lightGrey} disableShrink={viewMobile} />
                <Block width="99px" height="100%" radius="4px" bg={theme.colors.lightGrey} disableShrink={viewMobile} />
                <Block width="99px" height="100%" radius="4px" bg={theme.colors.lightGrey} disableShrink={viewMobile} />
              </Block>
              <Block width={!viewMobile ? '100%' : '260px'} height="246px" radius="4px" bg={theme.colors.lightGrey} />
            </Block>
          </Block>
          <Block bg={theme.colors.navy} align="center" justify="center" padding="50px 0">
            <Block width="466px" column={true} align="center" justify="center" gap="35px">
              <Block width="165px" height="25px" radius="5px" bg={theme.colors.white} />
              <Block
                width="100%"
                justify="space-between"
                align="center"
                gap={!viewMobile ? '30px' : '10px'}
                column={viewMobile}
              >
                <Block justify={!viewMobile ? 'space-between' : 'center'} gap="6px" align="center">
                  <Block width="13px" height="13px" radius="4px" bg={theme.colors.white} />
                  <Block width="79px" height="9px" radius="4px" bg={theme.colors.white} />
                </Block>
                <Block justify={!viewMobile ? 'space-between' : 'center'} gap="6px" align="center">
                  <Block width="13px" height="13px" radius="4px" bg={theme.colors.white} />
                  <Block width="79px" height="9px" radius="4px" bg={theme.colors.white} />
                </Block>
                <Block justify={!viewMobile ? 'space-between' : 'center'} gap="6px" align="center">
                  <Block width="13px" height="13px" radius="4px" bg={theme.colors.white} />
                  <Block width="79px" height="9px" radius="4px" bg={theme.colors.white} />
                </Block>
                <Block justify={!viewMobile ? 'space-between' : 'center'} gap="6px" align="center">
                  <Block width="13px" height="13px" radius="4px" bg={theme.colors.white} />
                  <Block width="79px" height="9px" radius="4px" bg={theme.colors.white} />
                </Block>
              </Block>
              <Block justify="center" align="center" gap="20px">
                <Block width="20px" height="20px" radius="4px" bg={theme.colors.white} />
                <Block width="20px" height="20px" radius="4px" bg={theme.colors.white} />
                <Block width="20px" height="20px" radius="4px" bg={theme.colors.white} />
              </Block>
              <Block justify="center" align="center" gap={!viewMobile ? '20px' : '10px'} column={viewMobile}>
                <Block
                  width={!viewMobile ? '121px' : '155px'}
                  height={!viewMobile ? '69px' : '40px'}
                  radius="4px"
                  bg={theme.colors.white}
                />
                <Block
                  width={!viewMobile ? '121px' : '155px'}
                  height={!viewMobile ? '69px' : '40px'}
                  radius="4px"
                  bg={theme.colors.white}
                />
                <Block
                  width={!viewMobile ? '121px' : '155px'}
                  height={!viewMobile ? '69px' : '40px'}
                  radius="4px"
                  bg={theme.colors.white}
                />
              </Block>
            </Block>
          </Block>
          <Block bg={theme.colors.lightGrey} justify="space-around" align="center" padding="48px 0 48px">
            <Block width="520px" gap="18px" justify="center" align="center">
              <Block
                height={!viewMobile ? '155px' : '170px'}
                width={!viewMobile ? '30%' : '170px'}
                radius="4px"
                bg={theme.colors.white}
                justify="center"
              />
              {!viewMobile && (
                <>
                  <Block height="155px" width={!viewMobile ? '30%' : '153px'} radius="4px" bg={theme.colors.white} />
                  <Block height="155px" width={!viewMobile ? '30%' : '153px'} radius="4px" bg={theme.colors.white} />
                </>
              )}
            </Block>
          </Block>
          <Block bg={theme.colors.white} justify="center" align="center">
            <Block
              width="510px"
              height={!viewMobile ? '204px' : '386px'}
              justify="space-between"
              align="center"
              margin={!viewMobile ? '56px 0' : '30px 0'}
              column={viewMobile}
            >
              <Block justify="center" width="222px" column={true} gap="10px" padding={viewMobile && '10px 0 0 20px'}>
                <Block width="161px" height="22px" margin="0 0 7px" radius="4px" bg={theme.colors.midGrey} />
                <Block width="146px" height="8px" radius="4px" bg={theme.colors.midGrey} />
                <Block width="146px" height="8px" radius="4px" bg={theme.colors.midGrey} />
                <Block width="107px" height="8px" margin="0 0 18px" radius="4px" bg={theme.colors.midGrey} />
                <Block width="118px" height="26px" radius="4px" bg={buttonColor} />
              </Block>
              <Block width={!viewMobile ? '288px' : '268px'} height="204px" radius="6px" bg={theme.colors.offWhite} />
            </Block>
          </Block>
          <Block
            className={classes.topAndBottomBorder}
            padding={!viewMobile ? '50px 0' : '30px 20px'}
            margin="auto"
            bg={theme.colors.white}
            justify="center"
            align="center"
          >
            {!viewMobile ? (
              <Block justify="space-between" align="center" width={!viewMobile && '63%'} gap="10px">
                <Block justify="center" width="auto" column={true} gap="10px">
                  <Block width="92px" height="12px" radius="4px" bg={theme.colors.midGrey} />
                  <Block width="66px" height="5px" radius="4px" bg={textLinkColour} />
                  <Block width="66px" height="5px" radius="4px" bg={textLinkColour} />
                  <Block width="66px" height="5px" radius="4px" bg={textLinkColour} />
                </Block>
                <Block justify="center" width="auto" column={true} gap="10px">
                  <Block width="92px" height="12px" radius="4px" bg={theme.colors.midGrey} />
                  <Block width="66px" height="5px" radius="4px" bg={textLinkColour} />
                  <Block width="66px" height="5px" radius="4px" bg={textLinkColour} />
                  <Block width="66px" height="5px" radius="4px" bg={textLinkColour} />
                </Block>
                <Block justify="center" width="auto" column={true} gap="10px">
                  <Block width="92px" height="12px" radius="4px" bg={theme.colors.midGrey} />
                  <Block width="66px" height="5px" radius="4px" bg={textLinkColour} />
                  <Block width="66px" height="5px" radius="4px" bg={textLinkColour} />
                  <Block width="66px" height="5px" radius="4px" bg={textLinkColour} />
                </Block>
                <Block justify="center" width="auto" column={true} gap="10px">
                  <Block width="92px" height="12px" radius="4px" bg={theme.colors.midGrey} />
                  <Block width="66px" height="5px" radius="4px" bg={textLinkColour} />
                  <Block width="66px" height="5px" radius="4px" bg={textLinkColour} />
                  <Block width="66px" height="5px" radius="4px" bg={textLinkColour} />
                </Block>
              </Block>
            ) : (
              <Block column={true} justify="center" align="center" gap="10px">
                <Block width="250px" height="32px" radius="4px" bg={theme.colors.midGrey} />
                <Block width="250px" height="32px" radius="4px" bg={theme.colors.midGrey} />
                <Block width="250px" height="32px" radius="4px" bg={theme.colors.midGrey} />
                <Block width="250px" height="32px" radius="4px" bg={theme.colors.midGrey} />
              </Block>
            )}
          </Block>
          <Block height="48px" align="center" justify="space-between" padding="10px 12px" bg={theme.colors.white}>
            <Block width="28px" height="28px" radius="4px" bg={theme.colors.teal} />
            <Block width="auto" gap="17px" justify="space-between">
              <Block width={!viewMobile ? '194px' : '104px'} height="8px" radius="4px" bg={theme.colors.midGrey} />
              <Block width="24px" height="8px" radius="4px" bg={theme.colors.teal} />
            </Block>
          </Block>
        </div>
      </DeviceWrap>
    </StyledLandingPagePreview>
  )
}

LandingPagePreview.defaultProps = {
  buttonColor: '#13174F',
  buttonTextColor: '#FFFFFF',
  textLinkColour: '#3FC0C3',
  gradientOne: '#13174F',
  gradientTwo: '#FFFFFF',
  viewMobile: false,
}

const LandingPageComponent = withStyles(styles)(LandingPagePreview)
LandingPageComponent.displayName = 'LandingPagePreview'
export default LandingPageComponent
